import { render, staticRenderFns } from "./AdminWorkplaceProfiler.vue?vue&type=template&id=04fe395c&"
import script from "./AdminWorkplaceProfiler.vue?vue&type=script&lang=js&"
export * from "./AdminWorkplaceProfiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports